module.exports = "/_next/static/images/icon_instagram-61179cde618f25f68536e651015ad908.svg";